import { queryData } from '@/domains/core/graphqlClient/queryClient';
import { getPlatform, isB2B } from '@/domains/core/settings/utils';
import type {
  BannerCampaign,
  UserSegments,
} from '@/domains/productDiscovery/CommercialAnimation/interfaces/bannerCampaign';
import { type Platform } from '@/generated/graphql/types';
import {
  ListingBottomTechnicalCampaignsDocument,
  ListingMiddleTechnicalCampaignsDocument,
} from '@/productDiscovery/CommercialAnimation/services/graphql/BannerCampaigns/generated/bannerCampaigns.query.generated';

export const fetchListingCampaignsGql = (
  bannerType: string,
  categoryIds: string,
  userSegments?: UserSegments,
) => {
  const categoryIdsArray = categoryIds
    ? categoryIds.split(',').map((id) => parseInt(id, 10))
    : [];

  const queryDocument =
    bannerType === 'listing' || bannerType === 'middle'
      ? ListingMiddleTechnicalCampaignsDocument
      : ListingBottomTechnicalCampaignsDocument;

  return queryData(queryDocument, {
    platform: getPlatform().toUpperCase() as Platform,
    market: isB2B() ? 'B2B' : 'B2C',
    userSegments: userSegments || {},
    categoryIds: categoryIdsArray,
  }).then((result: any) => (result.listingCampaigns || []) as BannerCampaign[]);
};
